import { TriangleAlert, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

type AlertVariant = 'error' | 'warning';

interface EventsAlertCardProps {
  icon?: LucideIcon;
  variant: AlertVariant;
  count: number;
  label: string;
  description?: string;
}

const variantStyles: Record<AlertVariant, string> = {
  error: 'text-destructive',
  warning: 'text-yellow-600 dark:text-yellow-500',
};

export function EventsAlertCard({
  icon,
  variant,
  count,
  label,
  description,
}: EventsAlertCardProps) {
  const Icon = icon ?? TriangleAlert;

  return (
    <div className='flex flex-col gap-1.5 p-3 bg-muted rounded-md shadow-sm'>
      <div className='flex items-center gap-2'>
        <Icon className={cn('size-4 shrink-0', variantStyles[variant])} />
        <span className='text-sm'>
          <span className='font-bold'>{count}</span>{' '}
          <span className='font-medium'>{label}</span>
        </span>
      </div>
      {description && (
        <p className='text-sm text-muted-foreground leading-snug pl-6'>
          {description}
        </p>
      )}
    </div>
  );
}
